import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { CanopyColor, StructureColor } from "../configurations/colors";
import { PergolaDesign } from "../data-stores/pergola";

const CREATE_CONFIGURATION_WITH_BUILD_ID_URL =
  "https://us-central1-paragon-outdoor-usa.cloudfunctions.net/createConfigurationV2";

export interface CreateCustomPergolaPayload {
  design: {
    pergola: PergolaDesign;
    color: StructureColor;
  };
  dimensions: {
    height: {
      feet: number;
      inches: number;
    };
    length: {
      feet: number;
      inches: number;
    };
    width: {
      feet: number;
      inches: number;
    };
  };
  canopy: {
    hasCanopy: boolean;
    color?: CanopyColor;
  };
  beams: number;
  price: number;
  buildNumber: string;
  isPingCall: boolean;
}

interface CreateCustomPergolaResponse {
  variantId: string;
  product: {
    id: string;
    title: string;
    variants: {
      nodes: Array<{
        id: string;
      }>;
    };
  };
}

export const functionsService = {
  createCustomPergola: async (
    data: CreateCustomPergolaPayload
  ): Promise<CreateCustomPergolaResponse> => {
    const result = await httpsCallable<
      CreateCustomPergolaPayload,
      CreateCustomPergolaResponse
    >(
      functions,
      "createCustomPergolaV2"
    )(data);
    return result.data;
  },
  createConfigurationWithBuildID: async (
    ownerId: string
  ): Promise<{ buildNumber: string }> => {
    const response = await fetch(CREATE_CONFIGURATION_WITH_BUILD_ID_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ownerID: ownerId,
      }),
    });
    return response.json();
  },
};
